(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-promotion-list-child"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const copyCodeButtons = document.querySelectorAll('.copy-code-button');
    copyCodeButtons.forEach(button => {
      button.addEventListener('click', function() {
        const code = this.closest('.promotion-item').querySelector('.code-text').textContent;
        navigator.clipboard.writeText(code);
        this.classList.add('copied');
        setTimeout(() => {
          this.classList.remove('copied');
        }, 2000);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
